import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollRateHistoryEntry } from "../../interface/payrollShuttle";

export const getPayrollRateHistory = async (
    token: string,
    setHistory: (history: IPayrollRateHistoryEntry[]) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.get(`${urlAPI}/payroll-rates/history`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        setHistory(response.data.message);
    } catch (error: any) {
        console.error(error);
        setError("Impossible de récupérer l'historique des taux.");
        dispatch(showSnackbar("Erreur lors du chargement de l'historique des taux.", "error"));
    }
};
